import React, { useEffect, useState } from "react";
import { Grid, Typography, Box, IconButton, Modal } from "@mui/material";
import { NewBBPSIcon } from "../../res/NewWebIcons";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { useNavigate } from "react-router-dom";

const userId = sessionStorage.getItem("userId");

const NewPayBills = () => {
  const [open, setOpen] = useState(false);
  const [services, setServices] = useState([]);
  const [error, setError] = useState(null);

  const navigate = useNavigate();
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const token = sessionStorage.getItem("jwtToken");

        if (!token) {
          throw new Error("Token not found in sessionStorage");
        }

        const response = await fetch(
          "https://api.ipaisa.co.in/myapp/billPayments/getAllCategory",
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error(`Error: ${response.status} ${response.statusText}`);
        }

        const responseData = await response.json();
        
        // Sort categories by their numeric key (C00, C01, etc.)
        const sortedCategories = responseData.body.data.sort((a, b) => {
          const numA = parseInt(a.categoryKey.substring(1));
          const numB = parseInt(b.categoryKey.substring(1));
          return numA - numB;
        });

        // Define the desired order for specific categories
        const priorityCategories = [
          "Mobile (Prepaid)",
          "Mobile (Postpaid)",
          "Electricity",
          "DTH",
          "Broadband",
          "Landline",
          "Water",
          "Gas",
          "Cable TV",
          "Credit Card",
          "Loan Repayment",
          "Insurance",
          "Municipal Taxes",
          "Housing Society",
          "Education",
          "Fastag"
        ];

        // Sort categories based on priority
        const reorderedCategories = priorityCategories
          .map(name => sortedCategories.find(cat => cat.categoryName === name))
          .filter(Boolean)
          .concat(
            sortedCategories.filter(
              cat => !priorityCategories.includes(cat.categoryName)
            )
          );

        // Map to services format
        const mappedServices = reorderedCategories.map((category) => ({
          icon: <img src={category.iconUrl} alt={category.categoryName} style={{ width: "50px", height: "50px" }} />,
          label: category.categoryName,
          categoryKey: category.categoryKey,
        }));

        // If userId is RE3456, remove Credit Card service
        if (userId === "RE3456") {
          const filteredServices = mappedServices.filter(
            (service) => service.label !== "Credit Card"
          );
          setServices(filteredServices);
        } else {
          setServices(mappedServices);
        }

      } catch (err) {
        setError(err.message);
      }
    };

    fetchServices();
  }, []);

  const handleServiceClick = (categoryKey, label) => {
    navigate(`/retailerServicesNew`, { state: { label, categoryKey } });
  };

  return (
    <Box sx={{ padding: "2rem", margin: "0 auto", marginTop: "4%" }}>
      {/* Header */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={4}
        sx={{
          flexDirection: { xs: "column", sm: "row" },
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          Recharge & Pay Bills On iPaisa
        </Typography>
        <NewBBPSIcon style={{ width: 120, height: "auto" }} />
      </Box>

      {/* Services Grid */}
      <Box
        sx={{
          backgroundColor: "white",
          padding: "1.5rem",
          borderRadius: "12px",
          boxShadow: "none",
        }}
      >
        <Grid container spacing={3}>
          {services.slice(0, 11).map((service, index) => (
            <Grid
              item
              xs={6}
              sm={4}
              md={3}
              key={index}
              sx={{
                textAlign: "center",
                cursor: "pointer",
              }}
            >
              <IconButton
                sx={{
                  backgroundColor: "rgba(2, 123, 254, 0.1)",
                  color: "#027BFE",
                  width: 60,
                  height: 60,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: "0 auto",
                  "&:hover": {
                    backgroundColor: "rgba(2, 123, 254, 0.5)", 
                  },
                }}
                onClick={() =>
                  handleServiceClick(service.categoryKey, service.label)
                }
              >
                 {React.cloneElement(service.icon, {
    style: { width: "50px", height: "50px" }, // Adjust the size here
  })}
              </IconButton>
              <Typography sx={{ mt: 1, fontSize: "0.875rem", fontWeight: 500 }}>
                {service.label}
              </Typography>
            </Grid>
          ))}

          {/* "More" Button */}
          <Grid
            item
            xs={6}
            sm={4}
            md={3}
            sx={{
              textAlign: "center",
              cursor: "pointer",
            }}
          >
            <IconButton
              sx={{
                backgroundColor: "rgba(2, 123, 254, 0.1)", // Set background with desired opacity
                color: "#027BFE",
                width: 90,
                height: 90,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                margin: "0 auto",
                "&:hover": {
                  backgroundColor: "rgba(2, 123, 254, 0.5)",  // Slightly darker on hover
                },
              }}
              onClick={handleOpen}
            >
              <MoreHorizIcon />
            </IconButton>
            <Typography sx={{ mt: 1, fontSize: "0.875rem", fontWeight: 500 }}>
              More
            </Typography>
          </Grid>
        </Grid>
      </Box>

      {/* Scrollable Modal */}
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: 800,
            maxHeight: "80vh",
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: "12px",
            p: 4,
            overflowY: "auto",
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={4}
          >
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              Other Services
            </Typography>
            <NewBBPSIcon style={{ width: 120, height: "auto" }} />
          </Box>
          <Grid container spacing={3}>
            {services.slice(11).map((service, index) => (
              <Grid
                item
                xs={6}
                sm={4}
                md={3}
                key={index}
                sx={{ textAlign: "center" }}
              >
                <IconButton
                  sx={{
                    backgroundColor: "rgba(2, 123, 254, 0.1)",
                    color: "#027BFE",
                    width: 60,
                    height: 60,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    margin: "0 auto",
                    "&:hover": {
                      backgroundColor: "rgba(2, 123, 254, 0.5)",
                    },
                  }}
                  onClick={() =>
                    handleServiceClick(service.categoryKey, service.label)
                  }
                >
                   {React.cloneElement(service.icon, {
    style: { width: "50px", height: "50px" }, // Adjust the size here
  })}
                </IconButton>
                <Typography
                  sx={{ mt: 1, fontSize: "0.875rem", fontWeight: 500 }}
                >
                  {service.label}
                </Typography>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Modal>
    </Box>
  );
};

export default NewPayBills;